<template lang="html">
  <d-select v-model="seller">
    <option v-if="defaulOption" disabled value="" selected>{{ label }}</option>
    <option
      :value="user.id"
      v-for="(user, index) in users"
      :key="index"
      :hidden="user.deleted_at"
    >{{ user.name }}</option>
  </d-select>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'select-seller',
  props: {
    model: {
      type: [Number, String],
    },
    defaulOption: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Selecione uma opção',
    },
  },
  computed: {
    users() {
      const { userList } = this.$store.state.user;
      if (userList && userList.list.length) {
        return userList.list;
      }
      return [];
    },
    seller: {
      get() {
        return this.model;
      },
      set(value) {
        return this.$emit('update:model', value);
      },
    },
  },
  methods: {
    ...mapActions([
      'getUserList',
    ]),
    getListUser() {
      if (this.users.length === 0) {
        const params = { skip: 0, take: 50, trashed: true };
        this.getUserList(params);
      }
    },
  },
  mounted() {
    this.getListUser();
  },
};
</script>
